// extracted by mini-css-extract-plugin
export var box = "Intro-module--box--363fd";
export var box_md = "Intro-module--box_md--ad233";
export var box_xmd = "Intro-module--box_xmd--6cc73";
export var box_flex = "Intro-module--box_flex--dc0b8";
export var box_lg = "Intro-module--box_lg--f12bc";
export var box_sm = "Intro-module--box_sm--3f81b";
export var box_outer = "Intro-module--box_outer--d161c";
export var box_whiteBg = "Intro-module--box_white-bg--236e5";
export var box_noMarginBottom = "Intro-module--box_no-margin-bottom--842d4";
export var box_noPadding = "Intro-module--box_no-padding--670ab";
export var box_outerGray = "Intro-module--box_outer-gray--14740";
export var box_dark = "Intro-module--box_dark--4eabf";
export var box_zIndex = "Intro-module--box_z-index--d6180";
export var box_zIndex6 = "Intro-module--box_z-index-6--b2a4d";
export var box_eventsWithLine = "Intro-module--box_events-with-line--14a30";
export var box_featuresAo = "Intro-module--box_features-ao--e2614";
export var box_verticalPaddings = "Intro-module--box_vertical-paddings--1212f";
export var clearP = "Intro-module--clearP--c243c";
export var clearP_vc = "Intro-module--clearP_vc--bc6ee";
export var innerContainer = "Intro-module--innerContainer--bdcf6";
export var layout = "Intro-module--layout--a636b";
export var title = "Intro-module--title--ffb67";
export var subtitle = "Intro-module--subtitle--a3ba3";
export var picture = "Intro-module--picture--8e565";
export var img = "Intro-module--img--f2b6f";
export var button = "Intro-module--button--d7860";
export var logoWrapper = "Intro-module--logoWrapper--306f3";
export var logo = "Intro-module--logo--0e57f";
export var fadeInAnimation = "Intro-module--fadeInAnimation--5923f";
export var placeHolderShimmer = "Intro-module--placeHolderShimmer--c1c5f";